/**
 * BannedPropertyIndicator Component
 * 
 * Displays a prominent red indicator for properties marked as "do not contact"
 * 
 * CRITICAL: This indicator ensures banned properties are visually obvious
 * to prevent accidental inclusion in mailshots.
 */

import React from "react";
import PropTypes from "prop-types";
import { FaBan } from "react-icons/fa";

export const BannedPropertyIndicator = ({ 
  inline = false, 
  showLabel = true,
  size = "normal" // "small" | "normal"
}) => {
  const baseStyle = {
    display: "inline-flex",
    alignItems: "center",
    gap: size === "small" ? "0.25rem" : "0.375rem",
    padding: size === "small" ? "0.125rem 0.375rem" : "0.25rem 0.5rem",
    backgroundColor: "#fee2e2",
    color: "#991b1b",
    borderRadius: "0.375rem",
    fontSize: size === "small" ? "0.75rem" : "0.8125rem",
    fontWeight: 600,
    border: "1px solid #fecaca",
  };

  const inlineStyle = {
    ...baseStyle,
    marginRight: "0.5rem",
  };

  return (
    <span style={inline ? inlineStyle : baseStyle} title="Property owner requested no contact">
      <FaBan style={{ fontSize: size === "small" ? "0.75rem" : "0.875rem" }} />
      {showLabel && <span>DO NOT CONTACT</span>}
    </span>
  );
};

BannedPropertyIndicator.propTypes = {
  inline: PropTypes.bool,
  showLabel: PropTypes.bool,
  size: PropTypes.oneOf(["small", "normal"]),
};

export default BannedPropertyIndicator;
